import React from 'react';
import { AdminAppointmentsTable } from '../adminAppointmentsTable/adminAppointmentsTable.component.js';

export const AdminAppointments = () => {
  return <AdminAppointmentsTable />
}